import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=8e510224&"
import script from "./consultant.vue?vue&type=script&lang=js&"
export * from "./consultant.vue?vue&type=script&lang=js&"
import style0 from "./consultant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consultant.vue"
export default component.exports